<template>
  <div class="landing-container" :class="containerClass" v-on:click="hideLanding">
    <h1 class="color-blue upcase text-center content-translate" :class="subHeaderInactive">Welcome To</h1>
    <div class="landing-header upcase text-center content-translate" :class="headerInactive">Changing Minds</div>
  </div>
</template>

<script>
  export default {
    data () {
      return {
        containerClass: '',
        subHeaderInactive: 'content-inactive',
        headerInactive: 'content-inactive'
      }
    },
    methods: {
      hideLanding () {
        this.containerClass = 'invisible'
        setTimeout(() => {
          this.containerClass = this.containerClass + ' hide-all'
        }, 1000)
      }
    },
    mounted () {
      setTimeout(() => {
        this.subHeaderInactive = ''
      }, 1000)
      setTimeout(() => {
        this.headerInactive = ''
      }, 2000)
      setTimeout(() => {
        this.hideLanding()
      }, 4500)
    }
  }
</script>


<style scoped lang="scss">

  @import '../../styles/variables';

  .landing-container {
    position: fixed;
    display: flex;
    align-items: center;
    justify-content: center;
    flex-direction: column;
    cursor: pointer;
    top: 0;
    left: 0;
    width: 100%;
    height: 100%;
    background: $body-bg;
    z-index: 100;
    transition: all 1s ease-in-out;
  }

</style>



// WEBPACK FOOTER //
// landing.vue?763daf4e